import Link from "next/link"
import { ResoltoWordmark } from "./resolto-brand"

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="marketing-container footer-grid">
        <div className="footer-brand">
          <ResoltoWordmark />
          <p>Developer-governed resolution for software teams.</p>
          <span className="demo-label">Pre-launch product build · no public claims</span>
        </div>
        <div>
          <h2>Product</h2>
          <Link href="/product">Product</Link>
          <Link href="/how-it-works">How it works</Link>
          <Link href="/integrations">Integrations</Link>
          <Link href="/pricing">Pricing</Link>
        </div>
        <div>
          <h2>Trust</h2>
          <Link href="/security">Security</Link>
          <Link href="/legal/privacy">Privacy placeholder</Link>
          <Link href="/legal/terms">Terms placeholder</Link>
        </div>
        <div>
          <h2>Access</h2>
          <Link href="/contact">Book a design-partner call</Link>
          <Link href="/sign-in">Sign in</Link>
          <Link href="/app">Open demo workspace</Link>
        </div>
      </div>
      <div className="marketing-container footer-bottom">
        <span>© 2026 Resolto working product.</span>
        <span>Legal pages require qualified review before launch.</span>
      </div>
    </footer>
  )
}
